import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, isChunkError: false };
  }

  static getDerivedStateFromError(error) {
    const isChunkError =
      error?.name === 'ChunkLoadError' ||
      /loading chunk/i.test(error?.message || '');
    return { hasError: true, isChunkError };
  }

  componentDidCatch(err, info) {
    const isChunkError =
      err?.name === 'ChunkLoadError' ||
      /loading chunk/i.test(err?.message || '');

    if (isChunkError) {
      // Stale PWA cache: old main.js references a chunk deleted by a new deploy.
      // Reload once to pick up the fresh bundle. sessionStorage guard prevents
      // infinite loops if the chunk is genuinely missing for another reason.
      if (!sessionStorage.getItem('aidey_chunk_reload')) {
        sessionStorage.setItem('aidey_chunk_reload', '1');
        window.location.reload();
      }
      return;
    }

    try {
      fetch('/api/log-error', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message: err.message,
          stack: err.stack,
          componentStack: info.componentStack,
          url: window.location.href,
        }),
      }).catch(() => {});
    } catch (_) {}
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    // Chunk error: reload is in progress — render nothing to avoid a flash
    if (this.state.isChunkError) return null;

    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        padding: '2rem',
        textAlign: 'center',
        fontFamily: "'Raleway', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        color: '#e0e0e0',
      }}>
        <div style={{
          background: 'rgba(255,255,255,0.04)',
          border: '1px solid rgba(255,255,255,0.08)',
          borderRadius: '16px',
          padding: '2.5rem 3rem',
          maxWidth: '420px',
          width: '100%',
        }}>
          <h2 style={{ margin: '0 0 0.75rem', fontSize: '1.25rem', color: '#f0f0f0', fontWeight: 700 }}>
            Something went wrong
          </h2>
          <p style={{ margin: '0 0 2rem', fontSize: '0.9rem', color: '#9ca3af', lineHeight: 1.6 }}>
            This section hit an error. Your data is safe.
          </p>
          <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: '10px 22px',
                background: '#f5c842',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                color: '#0a0a0f',
                fontWeight: 700,
                fontSize: '0.875rem',
                fontFamily: 'inherit',
              }}
            >
              Reload page
            </button>
            <button
              onClick={() => { window.location.href = '/'; }}
              style={{
                padding: '10px 22px',
                background: 'transparent',
                border: '1px solid rgba(255,255,255,0.15)',
                borderRadius: '8px',
                cursor: 'pointer',
                color: '#e0e0e0',
                fontWeight: 600,
                fontSize: '0.875rem',
                fontFamily: 'inherit',
              }}
            >
              Go to dashboard
            </button>
          </div>
        </div>
      </div>
    );
  }
}
